import Vue from 'vue';

import Button from '@components/ui/button.vue';

let PageComponent = {
  name: 'page404',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    't-button': Button,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#page-404');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/404';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/404/index.js